var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExternalLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0007 2.66683C9.63246 2.66683 9.33398 2.36835 9.33398 2.00016C9.33398 1.63197 9.63246 1.3335 10.0007 1.3335H14.0007C14.3688 1.3335 14.6673 1.63197 14.6673 2.00016V6.00016C14.6673 6.36835 14.3688 6.66683 14.0007 6.66683C13.6325 6.66683 13.334 6.36835 13.334 6.00016V3.60964L7.13872 9.8049C6.87837 10.0653 6.45626 10.0653 6.19591 9.8049C5.93556 9.54455 5.93556 9.12244 6.19591 8.86209L12.3912 2.66683H10.0007ZM3.33398 4.66683C2.96579 4.66683 2.66732 4.96531 2.66732 5.3335V12.6668C2.66732 13.035 2.96579 13.3335 3.33398 13.3335H10.6673C11.0355 13.3335 11.334 13.035 11.334 12.6668V8.66683C11.334 8.29864 11.6325 8.00016 12.0007 8.00016C12.3688 8.00016 12.6673 8.29864 12.6673 8.66683V12.6668C12.6673 13.7714 11.7719 14.6668 10.6673 14.6668H3.33398C2.22941 14.6668 1.33398 13.7714 1.33398 12.6668V5.3335C1.33398 4.22893 2.22941 3.3335 3.33398 3.3335H7.33398C7.70217 3.3335 8.00065 3.63197 8.00065 4.00016C8.00065 4.36835 7.70217 4.66683 7.33398 4.66683H3.33398Z",
    fill: "#B3B3B3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/external-link.4346b68f.svg";
export { ForwardRef as ReactComponent };